module.exports = __webpack_public_path__ + "assets/img/time.676bb9d7.svg";